import BaseActions from '@/store/base/actions'
import Schema from "@/store/modules/documentCategories/schema";
import api from '@/plugins/axios'
import * as Types from './../../mutationTypes'

const module = 'documentCategories'

export default BaseActions({module}, {
  async fetchModel({commit, getters}, data = []) {
    if(process.env.VUE_APP_DEBUG_MODE === 'true') console.log('%c>>> FETCH_MODEL: ', 'color: #c5b413', getters['getModuleTitle'])

    await api.post('/document-categories/get-by-key', {
      key: 'parent_uuid',
      value: data.value === 'main' ? null : data.value
    }, { trigger404: false })
        .then(res => {
          commit(Types.SET_MODEL, {
            key: data.value,
            list: res.data
          })
        })
  },

  setParentUuid({commit}, uuid) {
    commit(Types.SET_PARENT_UUID, uuid)
  },

  async fetchAllCategories({commit}) {
    await api.get('fetch-data/document-categories/all')
        .then(response => {
          commit(Types.SET_MODEL_LIST, response.data)
        })
  }
}, [Schema])
